import {ChangeDetectorRef, Component, NgZone, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthState, CognitoUserInterface, onAuthUIStateChange} from '@aws-amplify/ui-components';
import {SessionService} from '../services/session.service';
import {DataStore, I18n} from 'aws-amplify';
import { translations } from '@aws-amplify/ui';
import {User} from '../../models';
import {PermissionType} from '../API.service';
import {AuthenticatorService} from '@aws-amplify/ui-angular';

@Component({
    selector: 'app-login',
    templateUrl: './login.page.html',
    styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
    private authState: AuthState;
    private user: any;

    constructor(private ref: ChangeDetectorRef,
                private router: Router, private route: ActivatedRoute, private sessionService: SessionService, private ngZone: NgZone) {
        I18n.putVocabularies(translations);
        I18n.setLanguage('it');
    }

    async ngOnInit() {



        onAuthUIStateChange(async (authState, authData) => {
            
            this.authState = authState;
            this.user = authData as CognitoUserInterface;
            // @ts-ignore
            if (!this.ref.destroyed) {
                this.ref.detectChanges();
            }
            const v = {
                state: authState,
                user: authData,
            };
            if (this.authState == AuthState.SignedIn) {
                await this.sessionService.setAuthState(v);

                //   await this.router.navigate(['/home']);
                this.ref.detectChanges();
            }

        });
    }

    goHome() {
        this.router.navigate(['home']);
    }
}
